// Opción "vacía" de un <Select> de MUI v4 — ver feat_312 / feat_313.
//
// ⚠ Un `<MenuItem value="">` NO es una opción para MUI: es "sin selección".
// `Select/SelectInput.js` sólo calcula el label a mostrar dentro de
// `if (isFilled({ value }) || displayEmpty)`, e `isFilled("")` devuelve **false**
// (`InputBase/utils.js`) → `display` queda undefined y el Select pinta un
// **espacio de ancho cero** (`&#8203;`). La MISMA `isFilled` gobierna el shrink
// del `InputLabel` y el `notched` del `OutlinedInput`, así que la etiqueta
// además cae sobre el borde del campo. Resultado: el usuario elige la opción
// ("Cualquiera", "Sin especialidad", "Sin filtro") y la ve **en blanco**,
// idéntica a no haber elegido nada.
//
// Solución: darle a esa opción un CENTINELA con valor real, pero SÓLO en la
// capa de render. El estado del componente sigue guardando `""`, de modo que
// ninguna validación, filtro ni payload cambia de comportamiento y el centinela
// **no puede filtrarse al backend**:
//
//   <Select
//     value={toOption(x)}
//     onChange={e => setX(fromOption(e.target.value))}
//   >
//     <MenuItem value={EMPTY_OPTION}>Sin filtro</MenuItem>
//
// `displayEmpty` NO alcanza como alternativa: arregla el label del Select pero
// deja el notch cerrado (habría que sumar `InputLabelProps={{shrink:true}}` +
// `InputProps={{notched:true}}` en cada sitio).
//
// ⚠ El centinela NUNCA se guarda en el estado del componente. Hacerlo falla en
// silencio: el valor interno se cuela en el payload (un campo que viaja dentro
// de un objeto genérico se guardaría con él), pasa como truthy en una
// validación de obligatoriedad, o convierte un "sin filtro" en un query param
// con basura. Nada de eso tira un error — por eso hay UNA sola forma.

export const EMPTY_OPTION = "__empty__";

// Estado ("" / null / undefined) → lo que ve MUI.
export const toOption = value =>
  value === "" || value === null || value === undefined ? EMPTY_OPTION : value;

// Lo que devuelve MUI → estado (""), tal como estaba antes del centinela.
export const fromOption = value => (value === EMPTY_OPTION ? "" : value);
